module.exports = __webpack_public_path__ + "static/media/furqan_old.1ba8a7c2.png";